// switch from one bubble to another. Ensures that the dropdown content
// is not cleared until the dropdown has finished closing
export default ({ setCurrent, newIndex, setDesc, desc }) => {
  setCurrent(newIndex);
  setTimeout(() => {
    setDesc(desc);
  }, 299);
};
